import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import {LabelForm, LabelTotales, LabelValorTotales} from '../componentes_generales/componentes_formulario/labels';
import { formatearNumeroDecimal } from '../../funciones_globales/format';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import styled from 'styled-components';



const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;
class FormImpor13  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            importacion_sel:null,
            data_importaciones:[],
            total_importacion:0,
            numero_consolidado:'',
            numero_consolidado_mostrar:'',
            status_form:'G',
            colImportacion:[
                {   header: "Importación",
                    field: "Importacion",
                    width: 100,
                    type: "string"
                },
                {   header: "F.O.B",
                    field: "ValorFOB",
                    width: 100,
                    type: "num_decimal"
                },
                {   header: "",
                    field: "eliminar",
                    width: 100,
                    type: "link_elim",
                    suppressFilter: true,
                    suppressSorting: true
                }
            ],
            
        };
        this.gridImportacion = {
            context: {
                componentParent: this
            },      
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
               
			},
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.onGridImportacionReady= this.onGridImportacionReady.bind(this);
        this.immutablePush = this.immutablePush.bind(this);
        this.immutableDelete = this.immutableDelete.bind(this);
        this.guardar = this.guardar.bind(this)
        this.insertarImportacion= this.insertarImportacion.bind(this);
        this.eliminarImportacion=  this.eliminarImportacion.bind(this);
        this.getConsolidadoImportacion = this.getConsolidadoImportacion.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
    }
    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }
    onGridImportacionReady(params) {
		this.apiImportacion = params.api;
		this.gridApiColumnaImportacion = params.columnApi;
    }
    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });

    }
    methodFromParent(id, datos_fila) {
        let mensaje ="";    
        if(datos_fila.hasOwnProperty('Importacion') && datos_fila.hasOwnProperty("ValorFOB")){
            mensaje = window.confirm('¿Está seguro de eliminar la importacion: ' +datos_fila.Importacion+ '?'); 
            
            if (mensaje){
                this.eliminarImportacion(datos_fila ,id) 
            }
        } 

    }
    changeImportacion(value){
        let continuar =true;
        if(value !== null){
            if(Array.isArray(value))
            {
                if(value.length===0){
                    continuar=false;
                }
            }
            if(continuar){
                    this.setState({importacion_sel: value!==null?value:null})
                    global_axios.get('/importaciones/'+value.value+'/importacionencabezado')
                    .then((response)=>{
                        //Se procede a verificar si la importacion ya fue ingresada.
                        let encontrado = false;
                        for(let i=0; i < this.state.data_importaciones.length; i++){
                            if(this.state.data_importaciones[i].Importacion === response.data.ImportacionResponse.Importacion){
                                encontrado=true;
                            }
                        }
                        if(!encontrado){
                            this.insertarImportacion(response.data.ImportacionResponse)
                        }else{
                            alert('La Importación ya fue ingresada')
                        }
                       
                    })
                    .catch((err)=>{
                        alert(err.response?err.response.data.msg:err.message);  
                    });
            
                
            }else{
                this.setState({importacion_sel: null})
            }
            
        }else{
            this.setState({importacion_sel: null})
        }
        
    }
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }
    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }
    eliminarImportacion(importacion,index){
        let total = parseFloat(this.state.total_importacion) - parseFloat(importacion.ValorFOB);  
        this.setState({ data_importaciones: this.immutableDelete(this.state.data_importaciones, index), total_importacion:total});
    }
    insertarImportacion(importacion){
        let total = parseFloat(this.state.total_importacion) + parseFloat(importacion.ValorFOB);  
        this.setState({ data_importaciones: this.immutablePush(this.state.data_importaciones, importacion), total_importacion:total});
    }
    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0313')
         ])
        .then(() => {
            global_axios({
                method: 'GET',
                url: '/secuenciales/ConsolidadoImportacionId'
            }).then( response => {   
                let cod_secuencial = response.data.codigo;      
                this.setState({numero_consolidado_mostrar:cod_secuencial})     
            })
            .catch(error=>{
              this.props.cambiar_VisualizacionLoading(false);
              alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
            });
            
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0313');
    }

    limpiar(){
        this.setState({
            importacion_sel:null,
            data_importaciones:[],
            total_importacion:0,
            numero_consolidado:'',
            status_form:'G'
        })
    }
    guardar(){
        if(this.state.data_importaciones.length>0){
            let data= {
                secuencial:this.state.numero_consolidado,
                importaciones:this.state.data_importaciones,
            }
            this.props.cambiar_VisualizacionLoading(true);
            let url='';
            if(this.state.status_form==='G'){//GUARDAR
                url= '/importaciones/importacionconsolidada';
            }else{//MODIFICAR
                url= '/importaciones/importacionconsolidadamodificar';
            }
            global_axios(
                { method: 'POST',
                  url: url,
                  data: data
                }
              )
              .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg)
                global_axios({
                    method: 'GET',
                    url: '/secuenciales/ConsolidadoImportacionId'
                }).then( response => {   
                    let cod_secuencial = response.data.codigo;      
                    this.setState({numero_consolidado_mostrar:cod_secuencial})    
                    this.limpiar(); 
                })
                .catch(error=>{
                  this.props.cambiar_VisualizacionLoading(false);
                  alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
                });
              })
              .catch((err)=>{
                console.log(err)
                  this.props.cambiar_VisualizacionLoading(false);
                  alert('No se pudo procesar la transacción...');
              });
            console.log("EN EL METODO")
        }else{
            alert('Debe ingresar importaciones para continuar')
        }
        

    }
    getConsolidadoImportacion(){
        console.log(this.state.numero_consolidado)
        if(this.state.numero_consolidado!=='' && this.state.numero_consolidado!==null){
            global_axios.get('/importaciones/'+this.state.numero_consolidado+'/importacionconsolidada')
                    .then((response)=>{
                       if(response.data.ConsolidadoImportacionResponse!==null && response.data.ConsolidadoImportacionResponse.length>0){
                            //Se procede a llenar la tabla de importaciones consolidada.
                            let consolidados= response.data.ConsolidadoImportacionResponse;
                            let data_importaciones=[];
                            let total_importacion=0;
                            for(let i=0; i< consolidados.length;i++)
                            {
                                let objeto= {};
                                objeto.Importacion= consolidados[i].Importacion;
                                objeto.ValorFOB = consolidados[i].import.ValorFOB;
                                data_importaciones.push(objeto)
                                total_importacion=total_importacion+parseFloat(consolidados[i].import.ValorFOB)
                            }

                           this.setState({data_importaciones,total_importacion, status_form:'M'})                        
                       }else{
                           alert('No se encontraron registros para el numero de Consolidado Importación.')
                       }
                    })
                    .catch((err)=>{
                        console.log(err)
                        alert(err.response?err.response.data?err.response.data.msg:err.message:err.message);  
                    });
        }else{
            alert('Ingrese un numero consolidado de importación para continuar...')
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Consolidado Importación</TituloForm>
                <LabelCabecera>Consolidado Importación No: {this.state.numero_consolidado_mostrar}</LabelCabecera> 
            </HeaderForm>
                <CuerpoForm>

                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Numero de Consolidado:</LabelForm>
                            <InputSearch tipoInput='text' nombre='numero_consolidado' placeholder='Numero consolidado' valor={this.state.numero_consolidado} func_CambiarValor={this.handleInputChange}
                            func_BuscarValor={this.getConsolidadoImportacion} func_OnFocus={()=>{this.limpiar()}}/>
                        </ContainerCol> 
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Importación:</LabelForm>
                            <ReactSelectAsync value={this.state.importacion_sel}  func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.changeImportacion(value)}}/>
                        </ContainerCol> 
                    </Row>
                    <Row>
                        <div className='col-md-12'>   
                            <AgGridRender altura='200px' data={this.state.data_importaciones} columnas={this.state.colImportacion} 
                            gridOptions={this.gridImportacion} onGridReady={this.onGridImportacionReady}/>  
                        </div>
                    </Row>
                     <Row>
                        <div className='col-sm-6'>
                            <LabelTotales>Total Importacion: </LabelTotales>
                            <LabelValorTotales>{formatearNumeroDecimal(this.state.total_importacion)}</LabelValorTotales>
                        </div>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                            <br/>
                                <button type='button' className='btn btn-info btn-sm' onClick={this.guardar}><i className="fa fa-print fa-lg" aria-hidden="true"/> Guardar</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor13);